import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import {Router } from '@angular/router';
import { AuthenticationService } from '../_services/index';
import { HomeService } from '../_services/home.service';
import { filter } from 'rxjs/operators';
import { GoogleAnalyticsService } from '../_services/google-analytics.service';
import { data } from 'jquery';

@Component({
    selector: 'app-login',
    templateUrl: 'login.component.html',
    styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {
    model: any = {};
    loading = false;
    returnUrl: string;
    error = '';
    isAuthenticated: boolean;
    loginConfig: any = {};
    authConfig: any = {};
    loginIsvalid: boolean = false;
    loginAlertMessage: string = '';
    loginTitle: string = '';
    forgotPassword: any = {};
    loginMessage: any = {};
    extraLoginMessage: string = '';
    isExtraLoginMessage: boolean = false;
    showLoginImage: boolean = false;
    loginButtonLabel: string;
    i18n: any;
    loginTypes = ['SHP DBAuthenticator', 'SHP LdapAuthenticator']
    previousLocation: any;
    loginPageTitle: '';
    title: any;
    tempTitle: any;
    isSessionExceed: boolean = false;
    exceededUser: any ='';
    logonBannerWarningMessage: any;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private homeService: HomeService,
        private gaService : GoogleAnalyticsService) {
      
    }
  
    ngOnInit() {
        // reset login status
        this.homeService.sendMessage(true);
        this.authenticationService.removeLocalStorageItems();
        // this.authenticationService.logout();
        this.getLoginConfig();
        this.logonBannerConfig();
        // get return url from route parameters or default to '/'
        this.returnUrl = 'shp/' + this.route.snapshot.params.shortname + '/home' || '/';
        if(sessionStorage.getItem('i18n')){
            this.i18n = JSON.parse(sessionStorage.getItem('i18n'));
        }
        this.showAlert();
    }

    login() {
        this.loading = true;
        this.loginIsvalid = false;
        this.homeService.sendMessage(true);
        let redirectPostLoginUrl = this.authenticationService.getValueInConfigFromLocalStorage("redirectPostLoginUrl");
        if(redirectPostLoginUrl == null || redirectPostLoginUrl == 'undefined') {
            this.authenticationService.setValueInConfigAtLocalStorage("redirectPostLoginUrl", this.router.url.split("/")[1] + '/helpcenter');
        }
        this.authenticationService.login(this.model.username, this.model.password, String(this.homeService.institutionId),this.authConfig.loginType)
            .subscribe(
                data => {
                    let getConfigShortName = this.authenticationService.getConfig();
                    this.previousLocation = localStorage.getItem(getConfigShortName);
                    let lock = JSON.parse(this.previousLocation);
                    let location = lock.redirectPostLoginUrl;
                    if(location.includes('/tracker')){
                        let shortname = this.router.url.split('/')[1];
                        this.router.navigateByUrl(`${shortname}/tracker`);
                        this.homeService.sendMessage(false);
                    }else{
                       
                            this.router.navigate([this.router.url.split("/")[1],'helpcenter']);  
                            this.homeService.sendMessage(false);
                    }
                        
                },
                error => {
                    this.error = error;
                    this.loading = false;
                    this.loginAlertMessage = error.error.error_msg;
                    if(this.loginAlertMessage.includes('Exceeded the number of session(s)')){
                        this.isSessionExceed = true
                        this.exceededUser = error.error.return_body
                    }
                    this.homeService.sendMessage(false);
                    this.showAlert();                    
                });
    }

    getLoginConfig() {
        this.homeService.sendMessage(true);
        this.homeService.getLoginConfig().subscribe(res => {
            this.gaService.updatePageName();
            this.loginConfig = res.return_body.loginLabel;
            this.authConfig = res.return_body.authenticationConfig;
            console.log("AUTH CONFIG:", this.authConfig);

            if (!this.loginTypes.includes(this.authConfig.loginType)) {
                this.homeService.navigateToLogin(this.router.url.split("/")[1] + '/helpcenter');
            }
            this.loginMessage = res.return_body.loginMsg;
            if(this.loginConfig.optionalLabels[0].labelEnabler){
                this.loginTitle = this.loginConfig.optionalLabels[0].labelText;
            }
            if(this.loginConfig.optionalLabels[2].labelEnabler){
                this.forgotPassword.label = this.loginConfig.optionalLabels[2].labelText;
                this.forgotPassword.link = this.authConfig.forgetPwdLink;
            }
            if(this.loginMessage.optionalMsgs[1].messageEnabler){
                this.isExtraLoginMessage = true;
                this.extraLoginMessage = this.loginMessage.optionalMsgs[1].messageText;
            }
            if(this.loginConfig.imageSource){
                this.showLoginImage = true;
            }
            this.getHeaderConfig();
        });
    }

    getHeaderConfig() {
        this.homeService.sendMessage(true);
        this.homeService.getHeaderConfig().subscribe(res => {
          if(res.return_body.headerHyperLink[2]){
            this.loginButtonLabel = res.return_body.headerHyperLink[2].linkText;
          }
          this.homeService.sendMessage(false);
        });
    }

    handleNavigate(pathValue) {
        if(pathValue){
            window.location.href =  pathValue;
        }
    }
    handleNavigation(pathValue) {
        if(pathValue){
            this.router.navigate([this.router.url.split("/")[1],pathValue]);  
        }
    }

    showAlert(){
        if(this.loginAlertMessage){
            this.loginIsvalid = true;
        }else if(this.authenticationService.getTimeOut()){ //localStorage.getItem("isTimeOut")
            this.loginIsvalid = true;
            this.loginAlertMessage = this.i18n._value['shp.common.timeout.message'];
            this.authenticationService.removeTimeOut();
            //localStorage.removeItem("isTimeOut");
        }        
    }
    closeAlert(){
        this.loginIsvalid = false;
    }
    forceLogout(){
        console.log('force logout',this.exceededUser)
        this.homeService.forceLogout(this.exceededUser).subscribe(()=>{
            console.log("deleted the expired token")
            this.exceededUser = "";
            this.isSessionExceed = false;
            this.closeAlert()
        },error =>{
            console.log(error)
        })
    }
    logonBannerConfig(){
        this.homeService.logonBannerConfig().subscribe(res =>{   
            if(res.return_body != null &&  res.return_body.logonBannerWarningMessage != null && res.return_body.logonBannerWarningMessage.applyForSHP ){
                this.logonBannerWarningMessage = res.return_body.logonBannerWarningMessage.bannerMessage;
                console.log("Logon Banner Warning Message",this.logonBannerWarningMessage);
            }
        })
    }

}
